var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0Z",
    fill: "#00D3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 9.9995V8.5195C7.1001 6.6095 8.4501 5.8395 10.1001 6.7895L11.3801 7.5295L12.6601 8.2695C14.3101 9.2195 14.3101 10.7795 12.6601 11.7295L11.3801 12.4695L10.1001 13.2095C8.4501 14.1595 7.1001 13.3795 7.1001 11.4795V9.9995Z",
    fill: "#00D3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon04);
export default __webpack_public_path__ + "static/media/chat-icon-04.29ccc507d06e1159ec5f0df7526b3744.svg";
export { ForwardRef as ReactComponent };